class ModalMaterialDialogComponent extends HTMLElement {

  constructor() {
    super()
    document.addEventListener('project-loaded', (event) => { this.onUpdate(event.detail) })
    document.addEventListener('material-changed', (event) => { this.onUpdate(event.detail) })

    this.addEventListener('show.bs.modal', () => { if(this.project) { this.onUpdate(this.project) } })
  }

  /**
   * @param {BeamProject} project
   */
  onUpdate(project) {
    //document.getElementById('material-panel-text').innerHTML = project.materialName
    this.project = project
    if (project.isNorthAmericanSteel) {
      this.selectedButtonId = 'nav-steel-material-tab'
    } else if (project.isWood) {
      this.selectedButtonId = 'nav-wood-material-tab'
      this._onWoodMaterialSelected(project.material)
    } else if (project.isEngineeredLumber) {
      this.selectedButtonId = 'nav-wood-material-tab'
      this._onWoodMaterialSelected(project.material)
    } else if (project.isEuropeanSteel) {
      this.selectedButtonId = 'nav-european-steel-material-tab'
    } else if (project.isASTMSteel) {
      this.selectedButtonId = 'nav-astm-steel-material-tab'
    } else if (project.isAluminum) {
      this.selectedButtonId = 'nav-aluminum-material-tab'
    }
    const sel = document.getElementById(this.selectedButtonId)
    bootstrap.Tab.getOrCreateInstance(sel).show()
  }


  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="modal fade" id="modal-material-dialog" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-default text-white">
              <h4 class="modal-title" id="modal-material-selector-label">Select a Material</h4>
              <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button class="nav-link active h6" id="nav-steel-material-tab" data-bs-toggle="tab" data-bs-target="#steel-material-tab" type="button" role="tab" aria-controls="nav-home" aria-selected="true">American Steel</button>
                  <button class="nav-link h6" id="nav-wood-material-tab" data-bs-toggle="tab" data-bs-target="#wood-material-tab" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Lumber</button>
                  <button class="nav-link h6" id="nav-european-steel-material-tab" data-bs-toggle="tab" data-bs-target="#european-steel-material-tab" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">European Steel</button>
                  <button class="nav-link h6" id="nav-astm-steel-material-tab" data-bs-toggle="tab" data-bs-target="#astm-steel-material-tab" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">ASTM Steel</button>
                  <button class="nav-link h6" id="nav-aluminum-material-tab" data-bs-toggle="tab" data-bs-target="#aluminum-material-tab" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Aluminum</button>
                </div>
              </nav>
            
              <div class="tab-content py-3" id="modal-dialog-material-content">
                <div class="tab-pane fade show active" id="steel-material-tab" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div id="steel-material-table"></div>
                </div>

                <div class="tab-pane fade" id="astm-steel-material-tab" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div id="astm-steel-material-table"></div>
                </div>

                <div class="tab-pane fade" id="european-steel-material-tab" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div id="european-steel-material-table"></div>
                </div>

                <div class="tab-pane fade" id="aluminum-material-tab" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div id="aluminum-material-table"></div>
                </div>

                <div class="tab-pane fade" id="wood-material-tab" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div class="modal-body modal-body-shadow py-2">
                    <div class="" id="wood-material-heading" ></div>
                  </div>
                  <div class="accordion material-selector-body pt-2" id="wood-material-accordion"></div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      `

    this._initMetalMaterialTable(steelMaterialJson, 'steel-material-table', 'north-american-steel-material-selected')

    this._initMetalMaterialTable(astmSteelMaterialJson, 'astm-steel-material-table', 'astm-steel-material-selected')

    this._initMetalMaterialTable(europeanSteelMaterialJson, 'european-steel-material-table', 'european-steel-material-selected')

    this._initMetalMaterialTable(aluminumMaterialJson, 'aluminum-material-table', 'aluminum-material-selected')

    this._initWoodMaterialAccordion()
    
  }

  toggleMaterialButtons(buttonId) {
    this.selectedButtonId = buttonId
  }

  _clearMaterialTableSelection() {
    const tableIds = [
      'steel-material-table',
      'astm-steel-material-table',
      'european-steel-material-table',
      'wood-material-accordion',
      'aluminum-material-table'
    ]

    tableIds.forEach(id => {
      let rows = document.getElementById(id).getElementsByTagName('tr')
      for (let i = 1; i < rows.length; i++) {
        rows[i].classList.remove('material-table-row-selected')
      }
    })
  }

  _initMetalMaterialTable(materialJson, tableId, eventName) {

    const materials = materialJson

    let str = "<table class='table material-table'>"
    const eUnit = tableId === 'european-steel-material-table' ? "GPa" : "ksi"
    const fyUnit = tableId === 'european-steel-material-table' ? "MPa" : "ksi"
    for (let m in materials) {
      str += `<tr><td>${materials[m].Name}</td><td>Fy = ${materials[m].Fy} ${fyUnit}</td><td>E = ${materials[m].E} ${eUnit}</td></tr>`
    }
    str += '</table>'

    const table = document.getElementById(tableId)
    table.innerHTML = str

    const rows = table.getElementsByTagName("tr")
    for (let i = 0; i < rows.length; i++) {
      rows[i].onclick = () => {
        this._clearMaterialTableSelection()
        rows[i].classList.add('material-table-row-selected')
        document.dispatchEvent(new CustomEvent(eventName, { detail: materials[i] }))
        bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-material-dialog')).hide()
      }
    }
  }

  _initWoodMaterialAccordion() {
    let currentSpecies = '';
    let data = [];
    let grades = [];
    let str = '<div class="d-grid gap-2">'

    for (let m in woodVisual2to4MaterialJson) {
      const material = woodVisual2to4MaterialJson[m]
      if (currentSpecies !== material['Species']) {
        // species has changed
        if (currentSpecies !== '') {
          grades.sort(function (a, b) { return a.text > b.text })
          data.push({ species: currentSpecies, grades: grades })
        }
        currentSpecies = material['Species']
        grades = []
      }
      grades.push(material['Grade'])
    }

    for (let i in data) {
      const material = data[i]
      str += `
      
        <button class="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target="#wood-species-${i}" 
          aria-expanded="false" aria-controls="#wood-species-${i}">
          ${material.species}
        </button>
        

        <div id="wood-species-${i}" class="accordion-collapse collapse" aria-labelledby="wood-species-${i}" data-bs-parent="#wood-material-accordion">
          <div id="wood-species-${i}-body"></div>
        </div>

      `
    }

    str += '</div>'

    document.getElementById('wood-material-accordion').innerHTML = str

    let count = 0
    for (let i in data) {
      let material = data[i]
      str = '<div class="material-list-group text-center"><table class="table material-table">'
      for (let j in material.grades) {
        const woodMaterial = woodVisual2to4MaterialJson[count]
        str += `
          <tr id="wood-material-species-grade-${count}">
            <td class='pull-left2'>${woodMaterial['Grade']}</td>
            <td>Fb = ${parseFloat(woodMaterial['Fb'])}</td>
            <td>Ft = ${parseFloat(woodMaterial['Ft'])}</td>
            <td>Fv = ${parseFloat(woodMaterial['Fv'])}</td>
            <td>Fc = ${parseFloat(woodMaterial['Fc'])}</td>
            <td>E = ${parseFloat(woodMaterial['E']) / 1000} ksi</td>
          </tr>
        `
        count++
      }
      str += '</table></div>'
      document.getElementById(`wood-species-${i}-body`).innerHTML = str
    }

    count = 0
    for (let i in data) {
      let material = data[i]
      for (let j in material.grades) {
        const index = count
        document.getElementById(`wood-material-species-grade-${count}`).onclick = () => {
          this._clearMaterialTableSelection()
          this._onWoodGradeSelected(index)
          bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-material-dialog')).hide()
        }
        count++
      }
    }

    this._onWoodGradeSelected(0)
  }

  _onWoodMaterialSelected(woodMaterial) {
    let str = `
    <div class='fw-bold'>Currently Selected Wood Material</div>
    <table class='table wood-material-table' style="border: none;">
    <tr >
      <td class='pull-left2' style="border: none;"> ${woodMaterial['Species']} ${woodMaterial['Grade']}</td>
      <td style="border: none;">Fb = ${parseFloat(woodMaterial['Fb'])}</td>
      <td style="border: none;">Ft = ${parseFloat(woodMaterial['Ft'])}</td>
      <td style="border: none;">Fv = ${parseFloat(woodMaterial['Fv'])}</td>
      <td style="border: none;">Fc = ${parseFloat(woodMaterial['Fc'])}</td>
      <td style="border: none;">E = ${parseFloat(woodMaterial['E']) / 1000} ksi</td>
    </tr>
    </table>`
    document.getElementById('wood-material-heading').innerHTML = str
  }

  _onWoodGradeSelected(index) {
    const customEvent = new CustomEvent('wood-material-selected', { detail: woodVisual2to4MaterialJson[index] })
    document.dispatchEvent(customEvent)
    this._onWoodMaterialSelected(woodVisual2to4MaterialJson[index])
  }
}

customElements.define('modal-material-dialog', ModalMaterialDialogComponent);

function toggleMaterialButtons(button) {

  console.log(button)

  const buttonIds = [
      'steel-material-tab',
      'european-steel-material-tab',
      'astm-steel-material-tab',
      'wood-material-tab',
      'aluminum-material-tab'
  ]
  buttonIds.forEach( id => document.getElementById(id).className = 'btn btn-default button-shadow')
  if(button) { button.classList.add('btn-primary') }
}

function clearMaterialTableSelection() {
  const tableIds = [
      'steel-material-table',
      'astm-steel-material-table',
      'european-steel-material-table',
      'wood-material-accordion',
      'aluminum-material-table'
  ]

  tableIds.forEach( id => {
      let rows = document.getElementById(id).getElementsByTagName('tr')
      for (let i = 1; i < rows.length; i++) {
          rows[i].classList.remove('material-table-row-selected')
      }
  })
}
